import axios from 'axios';
import { SIGNUPURL } from '../index';

export const getSignupApi = (postData) => {
  return axios.post(SIGNUPURL, JSON.stringify(postData));
};